import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    defaultMessage: 'Create Return',
    description: 'Title for modal used to create a return',
    id: 'bnjMgD',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    description: 'Label for cancel button',
    id: 'KZOa5l',
  },
  continueButton: {
    defaultMessage: 'Continue',
    description: 'Label for continue button',
    id: 'sR1UMk',
  },
  shippedQuantity: {
    defaultMessage: 'Shipped Quantity',
    description: 'Label showing the quantity of an item that was shipped',
    id: '5ILBzk',
  },
});
